import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

export const ProjectInformationWrapper = styled.div`
  width: 100%;
`;

export const ProjectInformationContentWrapper = styled.div`
  padding-top: 32px;
  border-top: 1px solid #d2d6da;
  @media (${mediaQuery.tablet}) {
    margin: 0 24px;
  }
  ${media.xs`
    padding-top: 24px;
    margin: 0 16px;
  `};
  .detail-show-more {
    margin-bottom: 0;
  }
  .show-more-button {
    margin-top: 0;
    margin-bottom: 24px;
    ::before {
      display: none;
    }
  }
`;

export const ProjectInformationTitle = styled.h2`
  color: #333f48;
  font-size: 18px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: normal;
`;

export const ProjectInformationContent = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ProjectInformationAttribute = styled.div`
  width: 50%;
  margin-bottom: 24px;
  font-size: 14px;
  ${media.xs`
    width: 100%;
  `};
`;

export const ProjectInformationLabel = styled.p`
  margin: 0 0 4px;
  color: #697684;
  font-weight: 300;
  line-height: 1.43;
  letter-spacing: normal;
`;

export const ProjectInformationAttributeData = styled.p`
  margin: 0;
  color: #333f48;
  font-weight: 500;
  line-height: 1.43;
  letter-spacing: normal;
`;
